export const GET_MOBILE_APP_VERSION_CONFIG = `query {
  get_mobile_app_version_config {
    message
    data {
      current_version
      force_update
      update_message
    }
  }
}`;

export const UPDATE_MOBILE_APP_VERSION_CONFIG = `mutation ($currentVersion: String!, $forceUpdate: Boolean!, $updateMessage: String) {
  update_mobile_app_version_config(current_version: $currentVersion, force_update: $forceUpdate, update_message: $updateMessage) {
    message
  }
}`;
